import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export class ExportService {
  exportXlsx(options: {
    filename: string;
    rows: any[];
    columns: { key: string; header: string }[];
    accessors?: Record<string, (row: any) => any>;
  }) {
    const { filename, rows, columns, accessors } = options;

    const ordered = rows.map(r => {
      const out: Record<string, any> = {};
      for (const col of columns) {
        const v = accessors?.[col.key] ? accessors[col.key](r) : getValue(r, col.key);
        out[col.header] = v;
      }
      return out;
    });

    const ws = XLSX.utils.json_to_sheet(ordered);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Export');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`);

    function getValue(row: any, key: string) {
      // access dot paths if needed (we’ll pass pre-flattened rows, but keep this safe)
      return row?.[key] ?? key.split('.').reduce((acc: any, p) => (acc == null ? undefined : acc[p]), row);
    }
  }
}
